import React from 'react';

const About = () => {
  return (
    <section id="sobre" className="about-section">
      <div className="about-inner">
        <div className="about-image fade-in-up">
          <img src="/images/devs.webp" alt="Equipe DevCoski" />
        </div>
        <div className="about-content fade-in-up" style={{ animationDelay: '0.15s' }}>
          <p className="section-label">{"Sobre nós"}</p>
          <h2>
            {"Grandes desafios resolvidos com "}
            <span style={{ color: 'var(--primary)' }}>
              {"soluções estratégicas"}
            </span>
          </h2>
          <h4>
            {"Soluções digitais sob medida para o futuro da sua empresa."}
          </h4>
          <p>
            {"A "}
            <strong>Devcoski</strong>
            {" nasceu da visão de que grandes empresas frequentemente enfrentam grandes desafios que podem ser resolvidos com soluções pequenas, mas estratégicas. Fundada por um especialista em desenvolvimento de sistemas ERP, WMS e aplicações completas, a DevCoski tem como missão entender profundamente as dores dos clientes."}
          </p>
          <p>
            {"Com experiência em diversas tecnologias e um olhar atento às necessidades específicas de cada empresa, trabalhamos para criar sistemas ágeis, eficientes e escaláveis que impulsionam a eficiência operacional e o crescimento sustentável."}
          </p>
          <a href="#recursos" className="btn-primary-custom" style={{ marginTop: '0.5rem' }}>
            {"Conheça Nossos Projetos"}
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
